import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useId } from 'react';
import { cn } from '../utils/cn.js';
/**
 * Form field with label, optional helper hint, and inline error state.
 *
 * Callers MUST translate `label`/`hint`/`error` at the call site — the
 * package is i18n-agnostic on purpose.
 */
export const Input = forwardRef(function Input({ label, hint, error, id, className, ...rest }, ref) {
    const generatedId = useId();
    const inputId = id ?? generatedId;
    const helperId = hint ? `${inputId}-hint` : undefined;
    const errorId = error ? `${inputId}-error` : undefined;
    const describedBy = [errorId, helperId].filter(Boolean).join(' ') || undefined;
    return (_jsxs("div", { className: cn('clari-field', className), children: [_jsx("label", { className: "clari-field__label", htmlFor: inputId, children: label }), _jsx("input", { ref: ref, id: inputId, className: cn('clari-input', error && 'clari-input--error'), "aria-invalid": error ? true : undefined, "aria-describedby": describedBy, ...rest }), error ? (_jsx("span", { id: errorId, className: "clari-field__error", role: "alert", children: error })) : hint ? (_jsx("span", { id: helperId, className: "clari-field__hint", children: hint })) : null] }));
});
//# sourceMappingURL=Input.js.map